import { Avatar, AvatarFallback, AvatarImage } from '@e2n/ui';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { useTranslation } from 'react-i18next';
import { RotationsplanProgress } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/RotationsplanProgress';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';

export function Header({ rotationsplan }: { rotationsplan: Rotationsplan }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <Avatar>
            {rotationsplan.mitarbeiter.imgUrl ? (
              <AvatarImage
                alt={rotationsplan.mitarbeiter.getName()}
                src={rotationsplan.mitarbeiter.imgUrl}
              />
            ) : (
              <AvatarFallback>
                {rotationsplan.mitarbeiter.getInitials()}
              </AvatarFallback>
            )}
          </Avatar>
          <div className="font-semibold text-sm md:text-base">
            {rotationsplan.mitarbeiter.getName()}
          </div>
          <Location standort={rotationsplan.mitarbeiter.standort} />
        </div>
        <div className="font-extrabold text-xl md:text-2xl">
          {t('domain.mitarbeiter.rotationsplan.title')}{' '}
          {rotationsplan.beruf.name}
        </div>
      </div>
      <RotationsplanProgress rotationsplan={rotationsplan} />
    </div>
  );
}
